// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"36c818d7","318":"728d96b2","490":"e4ec610d","799":"e53a5af1"}[chunkId] + ".css";
};